import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";

import { Routes } from "../../../routes";
import handoverDocHtml from "./handoverDocHtml";

const DOC_TITLE = "Tài liệu bàn giao hệ thống VESO79";

const styles = {
  page: {
    position: "fixed",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    background: "#f5f6f8",
    zIndex: 1040,
  },
  bar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "10px 20px",
    background: "#ffffff",
    borderBottom: "1px solid #dde1e7",
    flex: "0 0 auto",
  },
  frame: {
    flex: "1 1 auto",
    width: "100%",
    border: 0,
    display: "block",
  },
};

export default () => {
  const history = useHistory();

  const openInNewTab = () => {
    const blob = new Blob([handoverDocHtml], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank", "noopener");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  };

  const goBack = () => {
    if (history.length > 1) {
      history.goBack();
      return;
    }
    history.push(Routes.SettingGames.path);
  };

  return (
    <div style={styles.page}>
      <div style={styles.bar}>
        <Button variant="light" size="sm" onClick={goBack}>
          <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
          Quay lại
        </Button>
        <Button variant="outline-primary" size="sm" onClick={openInNewTab}>
          <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
          Mở tab mới
        </Button>
      </div>

      <iframe title={DOC_TITLE} srcDoc={handoverDocHtml} style={styles.frame} />
    </div>
  );
};
